import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  TextField,
  FormControlLabel,
  Switch,
  CircularProgress,
  Grid,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import dayjs from 'dayjs';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import { authenticationService } from 'src/services/authentication.service';
import { useNavigate } from 'react-router';
import { get, post } from 'src/services/httpClient.service';

const AddCompany = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const [zonelist,setZoneList] = React.useState([])

  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    mobileNo: '',
    createdOn: dayjs().format('YYYY-MM-DDTHH:mm'),
    status: true,
    address1: '',
    address2: '',
    //address3: '',
    slogan: '',
    logo: '',
    //country: '',
    //state: '',
    zone: '',
    //city: '',
    tinNo: '',
    panNo: '',
    serviceTaxNo: '',
    entertainmentTaxNo: '',
    cstNo: '',
    website: '',
    operatorName: '', // 👈 fixed name
    operatorCode: '',
    areaOfOperation: '',
    gstNo: '',
    aadharNo: '',
    customerDocumentSavePath: '',
    franchiseDocumentSavePath: '',
    liveUrlLogoPathForEmail: '',
    areaId: "",
    areaName:"",
    vendorId: vendorId
  });

  // errors[fieldName] = 'error message'
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [areaList, setAreaList] = React.useState([]);
  const [selectedBillingAreaId, setSelectedBillingAreaId] = React.useState('');
  const [states, setStates] = useState<any[]>([]);
  const [cities, setCities] = useState<any[]>([]);
  const [loadingCities, setLoadingCities] = useState(false);
  const [loading, setLoading] = useState(false);

  // ---------- Validation helpers ----------

  const validateField = (name: string, value: string | boolean): string => {
    let error = '';

    switch (name) {
      case 'companyName':
        if (!String(value).trim()) error = 'Company name is required';
        break;

      case 'email':
        if (!String(value).trim()) {
          error = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value))) {
          error = 'Enter a valid email address';
        }
        break;

      case 'mobileNo':
        if (!String(value).trim()) {
          error = 'Mobile number is required';
        } else if (!/^\d{10}$/.test(String(value))) {
          error = 'Enter a valid 10-digit mobile number';
        }
        break;

      /*  case 'country':
         if (!String(value).trim()) error = 'Country is required';
         break; */

      /* case 'state':
        if (!String(value).trim()) error = 'State is required';
        break; */

      /* case 'city':
        if (!String(value).trim()) error = 'City is required';
        break; */

     /*  case 'zone':
        if (!String(value).trim()) error = 'Zone is required';
        break;
 */
      case 'gstNo':
        if (!String(value).trim()) {
          error = 'GST No is required';
        }
        // Optional: pattern check
        // else if (!/^[0-9A-Z]{15}$/.test(String(value))) {
        //   error = 'Enter a valid 15-character GST No';
        // }
        break;

      case 'panNo':
        if (!String(value).trim()) {
          error = 'PAN No is required';
        }
        // Optional PAN format:
        // else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(String(value))) {
        //   error = 'Enter a valid PAN';
        // }
        break;

      case 'aadharNo':
        if (!String(value).trim()) {
          error = 'Aadhar No is required';
        } else if (!/^\d{12}$/.test(String(value))) {
          error = 'Enter a valid 12-digit Aadhar No';
        }
        break;

      case 'website':
        if (String(value).trim()) {
          // simple URL check (optional)
          /*  const urlPattern = /^(https?:\/\/)?[^\s.]+\.[^\s]{2,}$/i;
           if (!urlPattern.test(String(value))) {
             error = 'Enter a valid website URL';
           } */
        }
        break;

      default:
        // Generic rule: if it's a string field and you want it required:
        if (typeof value === 'string' && !value.trim()) {
          // Make *everything* required:
          // comment this out if some fields should be optional
          // error = 'This field is required';
        }
        break;
    }

    return error;
  };

  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};

    Object.entries(formData).forEach(([key, value]) => {
      // skip fields you don’t want to validate:
      if (['vendorId'].includes(key)) return;

      const err = validateField(key, value);
      if (err) newErrors[key] = err;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const fetchAreas = async () => {
    try {
      const response = await get(
        `${APIURL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
      );
      if (response) setAreaList(response?.data);
      console.log('city', response?.data)
    } catch (error) {
      console.error("Error fetching areas", error);
    }
  };

  React.useEffect(() => {
    fetchAreas();
  }, []);

  // ---------- Handlers ----------


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    // Validate this field on change, so error disappears when valid
    const fieldError = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: fieldError }));
  };

  const handleStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setFormData((prev) => ({ ...prev, status: checked }));
    // if you need validation for status, add here
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const isValid = validateForm();
    if (!isValid) {
      showSnackbar('Please fix the highlighted errors.', 'error');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        // convert boolean status → string if API expects string:
        status: formData.status ? 'true' : 'false'
      };

      const response = await post(`${APIURL}/api/company`, payload);
      if (response) {
        showSnackbar('Company added successfully!', 'success');
        navigate('/company/Company');
      } else {
        showSnackbar('Failed to add company.', 'error');
      }
    } catch (error) {
      console.error('Error adding company:', error);
      showSnackbar('Error adding company.', 'error');
    } finally {
      setLoading(false);
    }
  };

  // ---------- Fetch states & cities ----------

  const fetchStates = async () => {
    try {
      const response = await get(`${APIURL}/states`);
      if (Array.isArray(response?.data)) {
        setStates(response.data);
      } else if (Array.isArray(response)) {
        setStates(response);
      }
    } catch (err) {
      console.error('Error fetching states', err);
    }
  };

  const fetchCities = async (stateName: string) => {
    if (!stateName) {
      setCities([]);
      return;
    }

    setLoadingCities(true);

    try {
      const response = await get(`${APIURL}/cities?stateName=${encodeURIComponent(stateName)}`);
      if (Array.isArray(response?.data)) {
        setCities(response.data);
      } else if (Array.isArray(response)) {
        setCities(response);
      }
    } catch (err) {
      console.error('Error fetching cities:', err);
      setCities([]);
    } finally {
      setLoadingCities(false);
    }
  };

  useEffect(() => {
    fetchStates();
    handlezonelist();
  }, []);


  const handlezonelist = async () => {
  
      try {
  
        const response = await get(`${APIURL}/api/miscellaneous/zone/vendor/${vendorId}/findAll`)
        console.log('zone', response?.data)
        setZoneList(response?.data)
  
      } catch (error) {
        console.log("zonelist", error)
      }
  
    }

  // ---------- JSX ----------

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, padding: 3 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Company Name"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            error={!!errors.companyName}
            helperText={errors.companyName}

          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="email"
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}

          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Mobile No"
            name="mobileNo"
            value={formData.mobileNo}
            onChange={handleChange}
            error={!!errors.mobileNo}
            helperText={errors.mobileNo}

          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="datetime-local"
            label="Created On"
            name="createdOn"
            value={formData.createdOn}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Address"
            name="address1"
            value={formData.address1}
            onChange={handleChange}
            error={!!errors.address1}
            helperText={errors.address1}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Landmark/Village"
            name="address2"
            value={formData.address2}
            onChange={handleChange}
            error={!!errors.address2}
            helperText={errors.address2}
          />
        </Grid>

        {/* <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Address 3"
            name="address3"
            value={formData.address3}
            onChange={handleChange}
            error={!!errors.address3}
            helperText={errors.address3}
          />
        </Grid> */}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Slogan"
            name="slogan"
            value={formData.slogan}
            onChange={handleChange}
            error={!!errors.slogan}
            helperText={errors.slogan}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Logo URL"
            name="logo"
            value={formData.logo}
            onChange={handleChange}
            error={!!errors.logo}
            helperText={errors.logo}
          />
        </Grid>

        {/* Country */}
        {/* <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            name="country"
            value={formData.country}
            onChange={handleChange}
            SelectProps={{ native: true }}
            error={!!errors.country}
            helperText={errors.country}
          >
            <option value="">Select Country</option>
            <option value="India">India</option>
          </TextField>
        </Grid> */}

        {/* State */}
        {/* <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            name="state"
            value={formData.state}
            SelectProps={{ native: true }}
            onChange={(e) => {
              const selectedState = e.target.value;
              setFormData((prev) => ({
                ...prev,
                state: selectedState,
                city: ''
              }));

              const fieldError = validateField('state', selectedState);
              setErrors((prev) => ({ ...prev, state: fieldError, city: '' }));

              fetchCities(selectedState);
            }}
            error={!!errors.state}
            helperText={errors.state}
          >
            <option value="">Select State</option>
            {states.map((s, i) => (
              <option key={i} value={s}>
                {s}
              </option>
            ))}
          </TextField>
        </Grid> */}

        {/* City */}
        {/* <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            name="city"
            value={formData.city}
            disabled={!formData.state}
            SelectProps={{ native: true }}
            onChange={handleChange}
            error={!!errors.city}
            helperText={errors.city}
          >
            <option value="">Select City</option>
            {loadingCities ? (
              <option disabled>Loading...</option>
            ) : (
              cities.map((city, i) => (
                <option key={i} value={city.cityName || city}>
                  {city.cityName || city}
                </option>
              ))
            )}
          </TextField>
        </Grid> */}

        <Grid item xs={6} >
          <Autocomplete
            options={areaList}
            loading={!areaList.length}

            value={
              areaList.find(
                (a) => String(a.id) === String(formData.areaId)
              ) ?? null
            }

            getOptionLabel={(option) =>
              `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
            }

            isOptionEqualToValue={(option, value) =>
              String(option.id) === String(value.id)
            }

            onChange={(_, newValue) => {
              setFormData((prev) => ({
                ...prev,
                areaId: newValue ? newValue.id : '',
                areaName: newValue ? newValue.cityName : ''
              }));
              console.log('newValue', newValue)
            }}

            inputValue={selectedBillingAreaId}
            onInputChange={(_, newInputValue) =>
              setSelectedBillingAreaId(newInputValue)

            }

            renderInput={(params) => (
              <TextField
                {...params}
                label="Area (City)"
                fullWidth
                error={!!errors.areaId}
                helperText={errors.areaId}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {!areaList.length && <CircularProgress size={18} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Zone */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <InputLabel>Zone</InputLabel>
            <Select
            name='zone'
            value={formData.zone}
            label="Zone"
            onChange={handleChange}
            >
              <MenuItem value="">Select Zone</MenuItem>
              {
                zonelist.map((zone)=>(
                  <MenuItem key={zone.id} value={zone.name}>
                    {zone.name}
                  </MenuItem>
                )
                )
              }
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="TIN No"
            name="tinNo"
            value={formData.tinNo}
            onChange={handleChange}
            error={!!errors.tinNo}
            helperText={errors.tinNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="PAN No"
            name="panNo"
            value={formData.panNo}
            onChange={handleChange}
            error={!!errors.panNo}
            helperText={errors.panNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Service Tax No"
            name="serviceTaxNo"
            value={formData.serviceTaxNo}
            onChange={handleChange}
            error={!!errors.serviceTaxNo}
            helperText={errors.serviceTaxNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Entertainment Tax No"
            name="entertainmentTaxNo"
            value={formData.entertainmentTaxNo}
            onChange={handleChange}
            error={!!errors.entertainmentTaxNo}
            helperText={errors.entertainmentTaxNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="CST No"
            name="cstNo"
            value={formData.cstNo}
            onChange={handleChange}
            error={!!errors.cstNo}
            helperText={errors.cstNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Website"
            name="website"
            value={formData.website}
            onChange={handleChange}
            error={!!errors.website}
            helperText={errors.website}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Operator Name"
            name="operatorName"
            value={formData.operatorName}
            onChange={handleChange}
            error={!!errors.operatorName}
            helperText={errors.operatorName}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Operator Code"
            name="operatorCode"
            value={formData.operatorCode}
            onChange={handleChange}
            error={!!errors.operatorCode}
            helperText={errors.operatorCode}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Area of Operation"
            name="areaOfOperation"
            value={formData.areaOfOperation}
            onChange={handleChange}
            error={!!errors.areaOfOperation}
            helperText={errors.areaOfOperation}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="GST No"
            name="gstNo"
            value={formData.gstNo}
            onChange={handleChange}
            error={!!errors.gstNo}
            helperText={errors.gstNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Aadhar No"
            name="aadharNo"
            value={formData.aadharNo}
            onChange={handleChange}
            error={!!errors.aadharNo}
            helperText={errors.aadharNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Customer Document Save Path"
            name="customerDocumentSavePath"
            value={formData.customerDocumentSavePath}
            onChange={handleChange}
            error={!!errors.customerDocumentSavePath}
            helperText={errors.customerDocumentSavePath}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Franchise Document Save Path"
            name="franchiseDocumentSavePath"
            value={formData.franchiseDocumentSavePath}
            onChange={handleChange}
            error={!!errors.franchiseDocumentSavePath}
            helperText={errors.franchiseDocumentSavePath}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Live URL Logo Path (Email)"
            name="liveUrlLogoPathForEmail"
            value={formData.liveUrlLogoPathForEmail}
            onChange={handleChange}
            error={!!errors.liveUrlLogoPathForEmail}
            helperText={errors.liveUrlLogoPathForEmail}
          />
        </Grid>

        {/* Status Switch */}
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.status}
                onChange={handleStatusChange}
                name="status"
                color="primary"
              />
            }
            label={formData.status ? 'Active' : 'Inactive'}
          />
        </Grid>

        {/* Buttons */}
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
            <Button
              variant="outlined"
              sx={{ mr: 2 }}
              onClick={() => navigate('/company/Company')}
            >
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Add Company'}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddCompany;
